/**
 * Facebook (Meta) Pixel integration.
 *
 * SDK loading: NOT loaded by tazio-fe. The fbq snippet is injected externally
 *              (typically by GTM tag or the customer portal).
 * Global:      window.fbq
 * Env vars:    none
 *
 * Status: ACTIVE — used opportunistically. Currently only one call site
 *         (SSO trackCustom event). No standard Pixel events (PageView,
 *         Purchase, AddToCart) are fired from tazio-fe — those are expected
 *         to come from GTM tags configured server-side.
 *
 * Existing call sites (as of 2026-04-13):
 *   - src/config.js:188-192    fbq('trackCustom', 'Sso', { customer, company, availability })
 *
 * Naming convention: every public function is prefixed with `facebook_pixel_`
 * so the Facebook Pixel origin is obvious at every call site, even when
 * imported alongside other integration modules.
 */

export function facebook_pixel_is_available() {
  return Boolean(window.fbq)
}

/**
 * Track a custom (non-standard) Pixel event.
 *   window.fbq('trackCustom', name, params)
 *
 * @param {string} event_name
 * @param {Object} [params]
 */
export function facebook_pixel_track_custom(event_name, params) {
  if (!facebook_pixel_is_available()) return
  window.fbq('trackCustom', event_name, params || {})
}

/**
 * Track a standard Pixel event (PageView, Purchase, AddToCart, ...).
 *   window.fbq('track', name, params)
 *
 * Provided for completeness / future use — not currently called by tazio-fe.
 */
export function facebook_pixel_track(event_name, params) {
  if (!facebook_pixel_is_available()) return
  window.fbq('track', event_name, params || {})
}
